import fontGroups from '../../fontGroups';
import { fontGroupDeclarations, normalizedBaseUrl } from '../../utilities';
export default (function (path) {
  var baseUrl = normalizedBaseUrl(path);
  return fontGroupDeclarations(fontGroups.ds_indigo, baseUrl);
});